<template>
  <a-upload
    :showUploadList="false"
    name="file"
    :action="url"
    :maxCount="maxCount"
    :multiple="multiple"
    :headers="headers"
    :accept="accept"
    @change="handleChange"
    :beforeUpload="beforeUpload"
  >
    <a-button>
      <upload-outlined></upload-outlined>
      上传文件
    </a-button>
    <span style="padding-left: 10px" v-if="tipText">{{tipText}}</span>
  </a-upload>
  <div class="file-list" v-if="fileList.length !== 0">
    <div class="file-list-item" v-for="(item, index) in fileList" :key="index">
      <a
        class="file-list-item-name"
        :href="item.file_path"
        target="_blank"
        :title="item.file_name"
        >{{ item.file_name }}</a
      >
      <a class="file-list-item-download" :href="item.file_path" target="_blank"
        ><download-outlined
      /></a>
      <delete-outlined class="file-list-item-del" @click.stop="del(index)" />
    </div>
  </div>
</template>
<script lang="ts">
import { message } from "ant-design-vue";
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  emits: ["uploadSuccess","beforeUploadFile"],
  props: {
    maxCount: {
      type: Number,
      default: 10000,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    tipText: {
      type: String,
      default: '',
    },
    beforeUpload: {
      type: Function,
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const url = ref<string>(
      `${process.env.VUE_APP_API_URL}/api/home/upload_file/`
    );
    const headers = ref({
      'SESSION-ID': store.getters.getToken,
    });
    const fileList = ref<any[]>([]);
    function handleChange(e: any) {
      if (e.file.status !== "uploading") {
        uploadSuccess(e.file);
      }
    }
    function uploadSuccess(res: any) {
      if (res.response.code === 2000) {
        if (props.maxCount == 1) {
          fileList.value = [res.response.data];
        } else {
          fileList.value.push(res.response.data);
        }
        emit("uploadSuccess", fileList.value);
      } else {
        message.warn(res.response.msg);
      }
    }
    // 上传文件之前
    // function beforeUpload(file:any) {
    //   emit("beforeUploadFile", file);
    // }
    // 删除
    function del(index: number) {
      fileList.value.splice(index, 1);
      emit("uploadSuccess", fileList.value);
    }
    return {
      url,
      fileList,
      headers,
      handleChange,
      del,
    };
  },
});
</script>
<style lang="stylus" scoped>
.file-list {
  display: flex;
  flex-direction: column;
}

.file-list-item {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.file-list-item-name {
  color: #333333;
}

.file-list-item-download {
  color: #1890ff;
  padding-left: 10px;
  font-size: 18px;
}

.file-list-item-del {
  color: red;
  padding-left: 10px;
  font-size: 18px;
}
</style>
